module.exports = __webpack_public_path__ + "static/media/thames-water-logo-charcoal.a5783dfc.svg";